import axios from 'axios'
import router from '@/router'

// API 서버 기본 URL (환경변수에서 가져옴)
const baseURL = process.env.VUE_APP_API

// Axios 인스턴스 생성
const instance = axios.create({
  baseURL: baseURL, // API 기본 경로
  headers: { 'content-type': 'application/json' }, // 기본 헤더
  timeout: 30000, // 요청 제한 시간 (30초)
  withCredentials: true, // 쿠키 포함 여부
  crossDomain: true, // CORS 허용
  credentials: 'include' // 크로스 인증 포함
})

// 요청 인터셉터
instance.interceptors.request.use(
  (config) => {
    // 로컬스토리지에 토큰이 있으면 헤더에 추가
    if (localStorage.getItem('token')) {
      config.headers['x-access-token'] = localStorage.getItem('token')
    }
    return config
  },
  (error) => {
    // 요청 자체가 실패하면 로컬스토리지 비움
    localStorage.clear()
    return Promise.reject(error)
  }
)

// 응답 인터셉터
instance.interceptors.response.use(
  (res) => {
    // 정상 응답 → 그대로 반환
    return res
  },
  (error) => {
    // 네트워크 오류 발생 시 에러 페이지로 이동
    if (error && error?.code === 'ERR_NETWORK') {
      return router.push({ name: 'errPage' })
    }

    // 서버 오류(500 이상) 발생 시 에러 페이지로 이동
    if (error.response && error.response.status >= 500) {
      return router.push({ name: 'errPage' })
    }

    // 현재 라우트 확인 (쿠폰 등록 예외 처리용)
    const currentRoute = router.currentRoute
    if (currentRoute.name !== 'couponExchange') {
      // 쿠폰 등록 페이지가 아니면 로컬스토리지 초기화
      localStorage.clear()
    }

    // 디버깅용 로그
    console.log('ERROR', error)

    // 에러를 다시 던져서 호출한 쪽에서 처리 가능하도록 함
    return Promise.reject(error)
  }
)

export default instance
